<template>
  <header class="header fixed up priority-4 hide-768">
    <i class="icon icon--union"></i>
  </header>
</template>

<script>
export default {
  name: 'SimpleNavigation',
};
</script>
